/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_RevokedInputs */

const cs_client_portal_revoked = /** @type {(inputs: Client_Portal_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístup do portálu zrušen.`)
};

const en_client_portal_revoked = /** @type {(inputs: Client_Portal_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal access revoked.`)
};

/**
* | output |
* | --- |
* | "Portal access revoked." |
*
* @param {Client_Portal_RevokedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_revoked = /** @type {((inputs?: Client_Portal_RevokedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_RevokedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_revoked(inputs)
	return cs_client_portal_revoked(inputs)
});